import { blocDConstants } from './constants';

export const initialState = {
  pending: false,
};

export function blocD(state = initialState, action) {
  switch (action.type) {
    case blocDConstants.GET_BLOCD_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case blocDConstants.GET_BLOCD_SUCCESS:
      return {
        ...state,
        [action.blocD.folderId]: action.blocD,
        pending: false,
      };
    case blocDConstants.UPDATE_BLOCD_REQUEST:
      return {
        ...state,
        [action.blocD.folderId]: action.blocD,
        error: null,
        pending: true,
      };
    case blocDConstants.UPDATE_BLOCD_SUCCESS:
      return {
        ...state,
        [action.blocD.folderId]: action.blocD,
        error: null,
        pending: false,
      };
    case blocDConstants.UPDATE_BLOCD_FAILURE:
      return {
        ...state,
        error: action.error,
        pending: false,
      };
    case blocDConstants.GET_BLOCD_FAILURE:
    default:
      return state;
  }
}
